<script>
  import { _ as t } from "svelte-i18n";

  export let errorMessages;
</script>

<style>
  .error-message {
    margin: 24px 0;
    color: red;
  }
</style>

{#each errorMessages as errorMessage}
  <div class="error-message">
    {#if errorMessage.key}{$t(`error.${errorMessage.key}`)}:{/if}
    {#each errorMessage.message as message}{$t(`error.${message}`)}{/each}
  </div>
{/each}
